module.exports = __webpack_public_path__ + "img/ebook-shopping-mall-cover.00c83ebf.jpg";